<template>
<div class="main">
  <h3 class="text-center">{{ title }}</h3>
  <table class="table table-responsive">
    <thead>
      <tr :class="type">
        <th v-for="(c, k) in columns"
            class="botable-column-title"
            unselectable="on"
            :key="k"
            @click="setSort(c.field)">
          {{ c.name }}
          <small v-if="sort === c.field"
                class="glyphicon"
                :class="sortGlyph()">
          </small>
        </th>
        <th v-if="actions.length > 0">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="u in page" :key="u[keyfield]"
          :class="{ active: u.id === selected }">
        <td v-for="(c, k) in columns" :key="k">
          {{ formatValue(u, c.field) }}
        </td>
        <td v-if="actions.length > 0">
          <span v-for="(a, k) in actions" :key="`${u[keyfield]}-${k}`">
            <a @click="trigger(a.event, u)">{{ a.name }}</a>&nbsp;
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  <pagination v-model="index" :total-page="pageCount"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'list',
  props: {
    columns: Array,
    actions: Array,
    list: Array,
    title: String,
    keyfield: String,
    selected: String,
    initialSort: String,
    type: String
  },

  data () {
    return {
      index: 1,
      countPerPage: 25,
      sort: this.initialSort,
      ascend: true,
      data: this.list
    }
  },

  watch: {
    list (val) {
      this.data = val
    }
  },

  computed: {
    sortedData () {
      const { sort, ascend } = this
      if (sort === '') {
        return this.data
      }

      const vm = this
      function compare (a, b) {
        const va = vm.getValue(a, sort)
        const vb = vm.getValue(b, sort)
        const sign = (ascend ? 1 : -1)

        if (va < vb) { return -sign }
        if (va > vb) { return sign }
        return 0
      }

      return this.data.slice().sort(compare)
    },

    page () {
      const { index, countPerPage } = this
      const start = (index - 1) * countPerPage
      return this.sortedData.slice(start, start + countPerPage)
    },

    pageCount () {
      return Math.ceil(this.list.length / this.countPerPage)
    },

    lineCount () {
      const count = this.data.length
      switch (count) {
        case 0:
          return 'Aucun résultat'
        case 1:
          return '1 résultat'
      }

      return `${count} résultats`
    }
  },

  methods: {
    trigger (event, data) {
      this.$emit(event, data)
    },

    setSort (sort) {
      if (this.sort === sort) {
        this.ascend = !this.ascend
      }
      this.sort = sort
    },

    sortGlyph () {
      if (this.ascend) {
        return 'glyphicon-sort-by-attributes'
      }

      return 'glyphicon-sort-by-attributes-alt'
    },

    getValue (data, field) {
      const list = field.split('.')
      let value = data
      for (let i in list) {
        value = value[list[i]]
      }
      return value
    },

    formatValue (data, field) {
      const value = this.getValue(data, field)

      switch (typeof value) {
        case 'boolean':
          if (value) { return 'Oui' }
          return 'Non'
        case 'object':
          if (value instanceof Array) {
            return value.join(', ')
          } else {
            return value
          }
        case 'string':
          const date = new Date(value)
          if (date.valueOf()) {
            if (date.getFullYear() <= 1) {
              return ''
            }
            return moment(date).format('DD/MM/YYYY')
          } else {
            return value
          }
        default:
          return value
      }
    }
  }
}
</script>

<style scoped lang="less">
.main {
    font-size: 85%;
}

a:hover {
    cursor: pointer;
}

.botable-column-title {
    cursor: pointer;
    -khtml-user-select: none;
    -ms-user-select:none;
    -moz-user-select:none;
    -webkit-user-select:none;
}

.botable-result-count {
    color: gray;
}

tr.success {
    color: white;
}
</style>
